import React from 'react'
import AboutPostHeader from '../ContactUs/AboutPostHeader'
import Footer from '../LandingPage/Footer'
import Header from '../LandingPage/Header'
import Navbar from '../LandingPage/Navbar'
import Box from './Box'
import CustomSeoBox from './CustomSeoBox'
const SearchEngine = () => {
    const data = [
        {
          step:"Step.1",
          head: "More Traffic",
          para:"As you gain more visibility, you will start to see an increase in the number of website visitors."
        },
        {
            step:"Step.2",

            head: "More Leads",
            para:"We can target the audience that is most likely to be interested in your products and services."
          },
          {
            step:"Step.3",

            head: "More Revenue",
            para:"The increase in targeted leads makes it easier to turn those leads into paying customers."
          },
          {
            step:"Step.4",

            head: "More Brand Awareness",
            para:"Your brand can become the one your customers think of over all the competition in the industry."
          },
          {
            step:"Step.5",

            head: "More Business Growth",
            para:"The new traffic, qualified leads, and brand awareness all contribute to new growth opportunities."
          },
          {
            step:"Step.6",

            head: "More Trust and Authority",
            para:"When you reach the top of the search results, your customers will see you as the industry authority."
          },
         
  

      ]
      var SeoArray = data.map((section) => {
        return (
          <Box
            step={section.step}
            head={section.head}
            para={section.para}
          />
        )
      })
      const dataTwo = [
        {
          img:"/health.png",
          head: "Site Health",
          para:"A lot of variables can impact your site’s overall health. Make sure algorithm changes, indexing errors, or manual actions aren’t causing problems."
        },
        {
            img:"/analysis.png",
            head: "Competitive Analysis ",
            para:"A lot of companies are competing for your keywords. We’ll analyze their strengths and weaknesses to find new opportunities for your success.."
          },
          {
            img:"/optimization.png",
            head: "Page Optimization",
            para:"Make sure your website converts visitors to paying customers and that it’s fully optimized to achieve the best rankings."
          },
          {
            img:"/link.png",
            head: "Link Building",
            para:"Links from high-quality sources drive relevant traffic to your site and help build authority in Google."
          },
          {
            img:"/month.png",
            head: "Monthly Reporting",
            para:"Stay completely in the loop with a monthly reporting schedule that shows everything we’ve done and how it has impacted your online presence."
          },
          {
            img:"/marketing.png",
            head: "Content Marketing",
            para:"Content is still king in the online world. This can include new on-page content, regular blogs, newsworthy press releases, or complete eBooks."
          },

      ]
      var customArray = dataTwo.map((section) => {
        return (
          <CustomSeoBox
            img={section.img}
            head={section.head}
            para={section.para}
          />
        )
      })
      const contact={
        head:"Technosoft Codex Professional Services",
      }
    return (
        <div>
            <Header />
            <Navbar />
            <AboutPostHeader obj={contact}/>
            <div className="container mt-5">
           <p>You can get an edge on the competition with a strong, integrated strategy that combines content marketing, research, technical SEO, social media, paid strategies, and other elements of online marketing.</p> 
       <p className="text-center font-weight-bold">When it all comes together in a single, unified strategy, you can expect:</p>
       <div className="row">
  {SeoArray}
    </div>
    <h2 className="text-center mt-5 font-weight-bold">What’s Included in Our Custom SEO Packages</h2>
    <div className="row">
{customArray}
    </div>
       </div>
      <Footer />
        </div>
    )
}

export default SearchEngine
